module.exports = __webpack_public_path__ + "19aff32f2120eb1d79b7f5e608fbc625.jpg";